import { ErrorPrompt } from '@karnov/kui-react'

import { useCountry } from 'hooks/useCountry'

import type { FC } from 'react'

type Props = {
  message?: string
}

const countryLocaleMap = {
  dk: 'da',
  se: 'sv',
} as const

export const ErrorPage: FC<Props> = ({ message }) => {
  const country = useCountry()

  const tempCountry = ['dk', 'es', 'fr'].includes(country) ? 'dk' : 'se'

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <ErrorPrompt locale={countryLocaleMap[tempCountry] || 'en'} errorMessage={message} hideButton />
    </div>
  )
}
